<template>
  <div class="outcome-container">
    <p class="text--l">{{outcomeText}}</p>
    <div class="spacer--l" />
    <a-btn @click="actionHandler">{{buttonLabel}}</a-btn>
  </div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn.vue";

export default {
  components: {ABtn},
  props: ['runner', 'customText'],
  data() {
    return {

    }
  },
  methods: {
    actionHandler() {
      switch (this.runner.getOutcome()) {
        case ('Approved'): {
          this.$emit('submitApproved');
          break;
        }
        case ('Pipeline'): {
          this.$emit('submitPipeline');
          break;
        }
        default: {
          this.$emit('submitRejected');
          break;
        }
      }
    }
  },
  computed: {
    buttonLabel() {
      switch (this.runner.getOutcome()) {
        case ('Approved'): {
          return `Let's go!`
        }
        case ('Pipeline'): {
          return `That'd be great, thanks!`
        }
        default: {
          return `Close`
        }
      }
    },
    outcomeText() {
      switch (this.runner.getOutcome()) {
        case ('Approved'): {
          return (this.customText && this.customText.confirmationText) || this.runner.getOutcomeText();
        }
        default: {
          return this.runner.getOutcomeText();
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  //display: flex;
  //flex-direction: column;
  flex-grow: 1;

  .runner-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    //align-content: center;
    //align-items: center;
    position: relative;
  }

}
.outcome-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    white-space: pre-wrap;
  }
}
</style>
